import './ColorIcon.scss'

const ColorIcon = ({color, hex=false})=>{
  return(
    <div className="row-color-options" style={{ backgroundColor:`${hex? color:`var(${color})`}`}} />
  )
}

export default ColorIcon;